import createModal from './../../modal/createModal'
import { createLoader, removeLoader } from '../../loader'
import { ajax } from '../../ajax'
import { goTo } from '../../services/window/location'
import { GET } from '../../services/api'
import { _ } from '../../gettext'

/**
 * Creates skills picker for creating service ticket.
 */
export function createSkillsPicker () {
  createLoader()
  ajax({
    method: GET,
    url: '/api-deprecated/system-user/get-skills/'
  }).then(({ data: skills }) => {
    if (Object.keys(skills).length === 0) {
      removeLoader()
      createModal(_('Upozornění'), _('Nemáte potřebnou kvalifikaci pro založení požadavku.')).show()
    } else if (Object.keys(skills).length === 1) {
      Object.keys(skills).forEach((guid) => {
        goTo('/service-ticket/add/?coreFacility=' + guid)
      })
    } else {
      removeLoader()

      let html = ''
      Object.keys(skills).forEach((guid) => {
        html += '<a class="btn btn-primary mb-2" href="/service-ticket/add/?coreFacility=' + guid + '">' +
                        skills[guid] + '</a><br />'
      })

      createModal(_('Vyberte laboratoř'), html).show()
    }
  })
}
